/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Create_TitleInputs */

const en_users_create_title = /** @type {(inputs: Users_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create user`)
};

const pt_br2_users_create_title = /** @type {(inputs: Users_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar usuário`)
};

/**
* | output |
* | --- |
* | "Create user" |
*
* @param {Users_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_create_title = /** @type {((inputs?: Users_Create_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Create_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_create_title(inputs)
	return pt_br2_users_create_title(inputs)
});